export const LocalStorageDataModel = {
  EMAIL: "email",
  USER_NAME: "userName",
  AUTH_TOKEN: "TaxmannAuthorization",
  MACHINEID: "machineid",
  VIDEO_AUTH_TOKEN: "video_token",
  EXTRA_NETCORE_PAYLOAD: "extraNetCorePayload",
  PREVIOUS_URL: "PREVIOUS_URL",
  NETCORE_EVENT_TRACK: "netcoreEventTrack",
  ENDMILE_EVENTS_CID_NUMBER: "endmileEventsCidNumber",
  USER_IP: "userIp",
  MACHINE_ID_NEW: "machineId1",
  MACHINE_ID: "machineId",
  ENDMILE_USER_DATA: "endmileUserData",
  UTM_CAMPAIGN_NAME: "activeCampaign",
  UTM_CAMPAIGN_URL: "activeCampaignUrl",
  SEARCH_PAGE_LAST_API_CALL_THROUGH: "searchPageLastApiCallThrough",
  CONTENT_TOKEN: "contenttoken",
  ISIPUSER: "isIpUser",
  PREMIUM_HEADER_STRIP:'premium_header_strip',
  FESTIVAL_DEAL:'popup_expire_date',
};
